import { Component, OnDestroy } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { UserService } from '../../../_core/services/user.service';
import { User } from '../../models/user.model';
import { AddPlayerComponent } from '../add-player/add-player.component';

@Component({
  standalone: false,
    selector: 'app-select-players',
    templateUrl: './select-players.page.html',
    styleUrls: ['./select-players.page.scss'],
})
export class SelectPlayersPage implements OnDestroy {
    authUser: User;
    selectedUsers: User[] = [];
    playerGroups = [];

    showMale = true;
    showFemale = true;

    private readonly destroy$: Subject<void> = new Subject();
    isLoading: boolean;


    constructor(
        private userService: UserService,
        private modalController: ModalController
    ) { }

    ionViewWillEnter() {
        this.getMyProfile();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private getMyProfile() {
        this.isLoading = true;
        this.userService
            .myProfile()
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => {
                    this.isLoading = false;
                })
            )
            .subscribe(
                (res) => {
                    this.authUser = res.data;
                    this.playerGroups = res.players;
                },
                err => {
                    //console.log(err)
                }
            );
    }

    async addPlayer() {
        const modal = await this.modalController.create({
            component: AddPlayerComponent,
        });

        await modal.present();

        const { data } = await modal.onDidDismiss();
        const lastNameFirstChar = data.last_name?.charAt(0)?.toUpperCase();

        const pgIndex = this.playerGroups.findIndex(pg => {
            return pg.initial === lastNameFirstChar;
        });
        if (pgIndex === -1) {
            this.playerGroups.push({
                initial: lastNameFirstChar,
                players: [data],
                count: 1
            });
        } else {
            this.playerGroups[pgIndex]?.players?.push(data);
        }
    }

    selectPlayer(i, j) {
        this.selectedUsers.push(this.playerGroups[i].players[j]);
        this.modalController.dismiss(this.selectedUsers);
    }

    canShowUser(sex) {
        if (sex === 'M') return this.showMale;
        else if (sex === 'F') return this.showFemale;
    }

    close() {
        this.modalController.dismiss();
    }

}
